import { Dialog } from '@headlessui/react';
import { Lock, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LockNoticeProps {
  open: boolean;
  onClose: () => void;
}

export function LockNotice({ open, onClose }: LockNoticeProps) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      className="relative z-50"
    >
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-md w-full rounded-2xl bg-gradient-to-b from-white to-gray-50 shadow-2xl border border-brand-200 p-8 transform transition-all duration-300">
          {/* Icon Container with Animation */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-brand-500/20 rounded-full blur-lg animate-pulse" />
              <div className="relative p-4 rounded-full bg-gradient-to-br from-brand-100 to-brand-50 border border-brand-200">
                <Lock className="h-8 w-8 text-brand-600" strokeWidth={1.5} />
              </div>
            </div>
          </div>

          {/* Title */}
          <Dialog.Title className="text-2xl font-bold text-center text-brand-900 mb-2">
            Stock Refill Mode
          </Dialog.Title>

          {/* Subtitle */}
          <div className="h-1 w-12 bg-gradient-to-r from-brand-400 to-brand-600 rounded-full mx-auto mb-6" />

          {/* Description */}
          <Dialog.Description className="text-center space-y-3 mb-8">
            <p className="text-gray-700 leading-relaxed">
              We're currently restocking our inventory and validating availability. New checkout orders are temporarily locked to ensure the best experience.
            </p>
            <div className="flex items-center justify-center gap-2 text-sm font-semibold text-brand-700 bg-brand-50 rounded-lg p-3 border border-brand-200">
              <RefreshCw className="h-4 w-4 animate-spin" />
              Please check again in a few minutes
            </div>
          </Dialog.Description>

          {/* Button */}
          <div className="flex justify-center">
            <Button 
              onClick={onClose} 
              className="bg-gradient-to-r from-brand-600 to-brand-700 hover:from-brand-700 hover:to-brand-800 text-white font-semibold px-8 py-2.5 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105"
            >
              Got It
            </Button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}